var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.addLogger = function (logger) {
        Logger.loggers.push(logger);
    };
    Logger.runAllLoggers = function (method, message, context) {
        try {
            Logger.loggers.forEach(function (logger) {
                logger[method](message, context);
            });
        }
        catch (error) {
            console.error('There was an error in the LoggerManager service', { method: method, error: error });
        }
    };
    Logger.log = function (message, context) {
        Logger.runAllLoggers('log', message, context);
    };
    Logger.info = function (message, context) {
        Logger.runAllLoggers('info', message, context);
    };
    Logger.warn = function (message, context) {
        Logger.runAllLoggers('warn', message, context);
    };
    Logger.error = function (message, context) {
        Logger.runAllLoggers('error', message, context);
    };
    Logger.loggers = [console];
    return Logger;
}());
export { Logger };
